import React from "react";
import CardSlide from "../Slider/card_slide";

export const SlideData = [
{
  id: 1,
  name: "Movement Bra",
  cate: "34,000 MMK",
  img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FMovement%20Bra%20(1).jpg?alt=media&token=1bce1424-eb54-4238-b7b9-2e5e4d31ce8a",
},
{
  id: 2,
  name: "Kardio bra",
  cate: "34,000 MMK",
  img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FKardio%20Bra%20(1).png?alt=media&token=c12864eb-065a-40fc-9454-5223f5208613",
},
{
  id: 3,
  name: "Halter Bra",
  cate: "34,000 MMK",
  img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FHalter%20Bra%20(1).jpg?alt=media&token=8b9c94a3-f18d-48d7-83c6-9d9a4651074e",
},
{
  id: 4,
  name: "Movement Bra",
  cate: "34,000 MMK",
  img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FFlow%20Bra%20(1).jpg?alt=media&token=47b981b3-0f6f-4589-8e81-88407c77adb9",
},
{
  id: 5,
  name: "Enhance bra",
  cate: "34,000 MMK",
  img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FEnhance%20Bra%20(1).png?alt=media&token=2b7ac1e4-06b7-4444-ae09-e0f9893d12df",
},
{
  id: 6,
  name: "Ace Sports Bra",
  cate: "34,000 MMK",
  img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FAce%20Bra%20(1).png?alt=media&token=2deab534-c195-4f3a-949a-3684a6195b34",
},
];
const SportBra = ({title,subTitle}) => {
return (
  <div>
    <div className="text-center mb-2 mt-10">
                <h2 className="uppercase text-[13px] ">{title}</h2>
                <h1 className="uppercase text-[22px]">{subTitle}</h1>
          </div>
    <CardSlide SlideData={SlideData} /> 
          <div className="text-center mt-4"><button className="bg-primary text-white  text-sm uppercase px-6 py-2 ">Shop now</button></div>
          <hr className="mt-10" />
  </div>
);
};

export default SportBra;
